module.exports = __webpack_public_path__ + "img/ibn-alhaythem.dea76446.png";